import { Coffee, ArrowUpRight, Sliders } from "lucide-react";
import { Link } from "react-router-dom";

const COFFEE_BUSINESS = {
  name: "The Grounded Cup",
  tagline: "Small-batch, ethically-sourced beans I actually drink between sessions.",
  image:
    "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export default function CoffeeSection() {
  return (
    <section id="coffee" className="py-20 md:py-28 px-6 md:px-12 scroll-mt-24">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <div className="overline mb-4">Coffee</div>
            <h2 className="font-serif-display text-4xl md:text-5xl font-medium tracking-tighter text-[#2D372B] leading-[1.02]">
              Two ways to share <span className="italic text-[#AD6A48]">a cup.</span>
            </h2>
          </div>
          <p className="max-w-md text-[#5C665A] leading-relaxed">
            Coaching is only half of what I do. The other half happens over a
            slow pour.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {/* Coffee Chat Card */}
          <div
            data-testid="hero-coffee-section"
            className="bg-white border border-[#E5E2D9] rounded-3xl p-8 md:p-10 flex flex-col justify-between"
          >
            <div>
              <div className="w-14 h-14 rounded-2xl bg-[#F7F5F0] border border-[#E5E2D9] flex items-center justify-center mb-6">
                <Coffee size={24} className="text-[#AD6A48]" />
              </div>
              <div className="overline mb-2">Free · 15 min</div>
              <h3 className="font-serif-display text-2xl md:text-3xl font-medium tracking-tight text-[#2D372B] leading-snug">
                Grab a coffee with me first.
              </h3>
              <p className="mt-3 text-[#5C665A] leading-relaxed">
                A no-pitch 15-minute call (or in-person, if you're local). Just
                a chance to talk through where you are and whether we'd be a
                good fit.
              </p>
            </div>
            <a
              href="#contact"
              data-testid="hero-coffee-cta"
              className="mt-8 inline-flex items-center gap-2 self-start rounded-full px-6 py-3 bg-[#2D372B] text-[#F7F5F0] font-medium hover:bg-[#89937C] transition-colors"
            >
              Book a coffee chat
              <ArrowUpRight size={16} />
            </a>
          </div>

          {/* Coffee Business Card */}
          <Link
            to="/coffee/customize"
            data-testid="coffee-business-card"
            className="group bg-white border border-[#E5E2D9] rounded-3xl overflow-hidden flex flex-col hover:shadow-lg transition-all duration-500 hover:-translate-y-1"
          >
            <div className="aspect-[16/9] overflow-hidden bg-[#E5E2D9]">
              <img
                src={COFFEE_BUSINESS.image}
                alt={COFFEE_BUSINESS.name}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="p-8 md:p-10 flex flex-col flex-1 justify-between">
              <div>
                <div className="overline mb-2">My other venture</div>
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-serif-display text-2xl md:text-3xl font-medium tracking-tight text-[#2D372B] leading-snug">
                    {COFFEE_BUSINESS.name}
                  </h3>
                  <Sliders
                    size={18}
                    className="text-[#89937C] mt-2 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </div>
                <p className="mt-3 text-[#5C665A] leading-relaxed">
                  {COFFEE_BUSINESS.tagline}
                </p>
              </div>
              <div
                data-testid="coffee-customize-link"
                className="mt-6 inline-flex items-center gap-2 text-[#2D372B] font-medium"
              >
                Customize your bag — roast, grind &amp; size
                <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
